import { createFileRoute, redirect } from "@tanstack/react-router";
import { Billing } from "@/features/subscriptions";

const Route = createFileRoute("/_authorized/subscription/billing/")({
  beforeLoad: ({ location }) => {
    if (!location.state.fromPrevious) {
      redirect({ to: "/subscription/overview", replace: true, throw: true });
    }
  },
  component: () => <Billing />,
});

export { Route };
